var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_147)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#255AEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2944 9.85359L13.7477 19.0669L11.2144 16.3603C10.7477 15.9203 10.0144 15.8936 9.48103 16.2669C8.96103 16.6536 8.81436 17.3336 9.13436 17.8803L12.1344 22.7603C12.4277 23.2136 12.9344 23.4936 13.5077 23.4936C14.0544 23.4936 14.5744 23.2136 14.8677 22.7603C15.3477 22.1336 24.5077 11.2136 24.5077 11.2136C25.7077 9.98692 24.2544 8.90692 23.2944 9.84025V9.85359Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_147"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerRight);
export default __webpack_public_path__ + "static/media/banner-right.675d0493f7072af0027106a801f20507.svg";
export { ForwardRef as ReactComponent };